import { toast } from '@/components/Toast';
import { clearGuestCheckoutCache } from '@/domain/payment/guest-checkout/browser-cache';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';

interface LoginSuccessData {
  token: string;
  customer?: any;
  msg?: string;
}

export default function useLoginSuccess() {
  const setToken = useStore((state) => state.setToken);
  const setUserInfo = useStore((state) => state.setUserInfo);
  const setWishNum = useStore((state) => state.setWishNum);
  const setCart = useStore((state) => state.setCart);
  const resolveCaLensFlowExperiment = useStore((state) => state.resolveCaLensFlowExperiment);

  const handleLoginSuccess = async (data: LoginSuccessData) => {
    try {
      // 设置token和用户信息到store (localStorage存储会在setToken和setUserInfo方法内部处理)
      setToken(data.token);
      if (data.customer) {
        setUserInfo(data.customer);
        setWishNum(data.customer.wish_num);
      }
      // 登录后由后端按账号身份重新返回 A/B 分组；不复用游客态结果。
      void resolveCaLensFlowExperiment({ force: true });
      if (data.customer) {
        setCart();
      }

      clearGuestCheckoutCache();

      // 显示成功消息
      if (data.msg) {
        toast.success(data.msg);
      }
    } catch (error) {
      logger.error('Failed to handle login success:', error);
      throw error;
    }
  };

  return { handleLoginSuccess };
}
